import moment from "moment";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { ZERO_DIGIT } from "../../constants/env";
import type { IdDetailParams } from "../interfaces/IdDetailParams.interface";
import { useLegacyServiceRequestApi } from "./useLegacyServiceRequestApi";

const STATUS_STEPS_NUMBER_BEFORE_SENDING = 1;

export function useChatWithOperatorState() {
  const { id: practiceId } = useParams<IdDetailParams>();
  const parsedPracticeId = practiceId ? parseInt(practiceId, 10) : 0;
  const { serviceRequest } = useLegacyServiceRequestApi(parsedPracticeId);

  const hasTwoMonthsPassedSincePracticeOpened = useMemo(
    function memoizeHasBeenTwoMonths() {
      const hasBeenTwoMonths =
        moment(serviceRequest?.lastTurnUpdateAt).valueOf() <= moment().subtract(2, "months").valueOf();
      return hasBeenTwoMonths;
    },
    [serviceRequest]
  );

  const isChatEnabled = useMemo(
    function memoizeIsChatEnabled() {
      const isPracticeStatusZero = (serviceRequest?.status ?? ZERO_DIGIT) === ZERO_DIGIT;

      return isPracticeStatusZero || !hasTwoMonthsPassedSincePracticeOpened;
    },
    [serviceRequest, hasTwoMonthsPassedSincePracticeOpened]
  );

  const isPracticeSentToOperator = useMemo(
    function memoizeIsPracticeSentToOperator() {
      const sentToOperator = (serviceRequest?.serviceStatus ?? []).length > STATUS_STEPS_NUMBER_BEFORE_SENDING;

      return sentToOperator;
    },
    [serviceRequest]
  );

  return {
    isChatEnabled,
    isPracticeSentToOperator,
    hasTwoMonthsPassedSincePracticeOpened,
  };
}
